import React from 'react';

interface FullscreenButtonProps {
  isFullscreen: boolean;
  onClick: () => void;
}

export const FullscreenButton = React.memo(function FullscreenButton({ isFullscreen, onClick }: FullscreenButtonProps) {
  return (
    <button
      className={`kollab-player-btn kollab-player-fullscreen-btn ${isFullscreen ? 'kollab-player-fullscreen-btn--active' : ''}`}
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      data-tooltip={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      onClick={onClick}
      type="button"
    >
      <span className="kollab-player-btn-icon" aria-hidden="true" />
    </button>
  );
});
